import { Pipe, PipeTransform } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import {
  PayoffScheduleEnum,
  ScheduleType,
} from 'src/app/product-capture/model/enums/product-capture.enums';
import { BarrierType } from 'src/app/static-data/models/consts/barrier-types.const';
import { NumberUtils } from '../../../../utils/number.utils';

@Pipe({
  name: 'barrierLevel',
})
export class BarrierLevelPipe implements PipeTransform {
  transform(
    values: any[],
    form: UntypedFormGroup,
    editForm: UntypedFormGroup,
    groupName: number,
    type: ScheduleType,
    levelRange?: 'upper' | 'lower'
  ): string {
    const barrier = form.value.barrier;
    const barrierType = barrier.type;
    const barrierLevel = editForm.value.barrierLevel;
    const deferredPeriods = NumberUtils.stringToNumber(
      form.value.deferredPeriods
    );
    const fixedPeriods = NumberUtils.stringToNumber(form.value.fixedPeriods);
    const period = NumberUtils.stringToNumber(
      editForm.get(PayoffScheduleEnum.period)?.value
    );

    if (type === ScheduleType.CALLABILITY && groupName + 1 <= deferredPeriods) {
      return 'Deferred';
    }

    if (fixedPeriods && groupName + 1 <= fixedPeriods) {
      return '-';
    }

    if (!levelRange) {
      if (barrierType === BarrierType.CUSTOM) {
        return barrierLevel?.value;
      }

      if (barrierType === BarrierType.FLAT) {
        return barrier.level?.value;
      }

      if (barrierType === BarrierType.STEPPED) {
        return this.calculateSteppedBarrier(
          barrier.level?.value,
          barrier.stepSize?.value,
          period,
          deferredPeriods || fixedPeriods,
          type
        );
      }

      return '';
    }

    if (barrierType === BarrierType.FLAT) {
      return barrier?.[`${levelRange}Level`]?.value;
    }

    if (barrierType === BarrierType.CUSTOM) {
      return editForm.value?.[`${levelRange}Level`]?.value;
    }

    return this.calculateSteppedBarrier(
      barrier[`${levelRange}Level`]?.value,
      barrier[`${levelRange}StepSize`]?.value,
      period,
      deferredPeriods || fixedPeriods,
      type
    );
  }

  stripPercentSign(percent: string): number {
    if (percent) {
      return Number(percent.replace(/%/g, ''));
    }
    return null;
  }

  calculateSteppedBarrier(
    level: string,
    stepSize: string,
    period: number,
    deferredPeriods: number,
    scheduleType: ScheduleType
  ): string {
    if (!level || !stepSize || !period) {
      return '';
    }

    const numberType = level.indexOf('%') > -1 ? '%' : '';

    period = deferredPeriods ? period - deferredPeriods : period;

    const value =
      NumberUtils.stringToNumber(level) +
      (period - 1) * NumberUtils.stringToNumber(stepSize);

    return typeof value === 'string'
      ? (value as string)?.trim().length
        ? value
        : ''
      : `${value}${numberType}`;
  }
}
